import React from "react";


import { Dialog } from "../../components/Dialogs/Dialog";
import { StandadCard } from "../../components/Cards";
import { StandardCellList } from "../../components/Standards";
import { Grid } from "@mui/material";


export interface IOfferDialog {
    open: boolean;
    onClose: () => void;
    offer: {
        offer_id: number;
        offer_code: string;
        offer_name: string;
        offer_description: string;
        offer_type: string;
        image_url: string;
        promo_code: string;
        status: string;
        package_json: {
            package_id: number;
            package_name: string;
            package_type: string;
            package_price: number;
            gst_amount: number;
            gst_percentage: number;
            no_of_services: number;
            city: string;
            status: string;
            partner_name: string;
            vehicle_type: string;
            duration: number;
            package_duration_type: string;
            additional_features?: {
                [key: string]: string;
            };
            plan_benefits?: Array<{ [key: string]: string }>;
        };
        create_dt: string;
        insert_dt: string;
        comment?: string | null;
    };
}

export const ViewofferDailog: React.FC<IOfferDialog> = (
    props
) => {
    const { open, offer, onClose } = props;

    return (
        <Dialog
            open={open}
            title="Offer Details"
            onClose={onClose}
            size="md"
            actions={[
                { type: "button", label: "Close", variant: "text", onClick: onClose },
            ]}
        >
            <Grid container spacing={1}>
                <Grid item xs={12} lg={12}>
                    <StandadCard heading="Offer Details" sx={{ mb: 2 }}>
                        <StandardCellList
                            colSize={3}
                            list={[
                                {
                                    heading: "Offer ID",
                                    data: {
                                        type: "text",
                                        value: offer.offer_id,
                                    },
                                },
                                {
                                    heading: "Offer Code",
                                    data: {
                                        type: "text",
                                        value: offer.offer_code,
                                    },
                                },
                                {
                                    heading: "Offer Name",
                                    data: {
                                        type: "text",
                                        value: offer.offer_name,
                                    },
                                },
                                {
                                    heading: "Offer Description",
                                    data: {
                                        type: "text",
                                        value: offer.offer_description,
                                    },
                                },
                                {
                                    heading: "Offer Type",
                                    data: {
                                        type: "text",
                                        value: offer.offer_type,
                                    },
                                },
                                {
                                    heading: "Image URL",
                                    data: {
                                        type: "text",
                                        value: <img src={offer.image_url} alt="Offer Image" width={100} height={100} />,
                                        color:
                                            offer.status === "ACTIVE"
                                                ? "success.main"
                                                : "error.main",
                                    },
                                },
                                {
                                    heading: "Promo Code",
                                    data: {
                                        type: "text",
                                        value: offer.promo_code,
                                    },
                                },
                                {
                                    heading: "Status",
                                    data: {
                                        type: "text",
                                        value: offer.status,
                                        color:
                                            offer.status === "ACTIVE"
                                                ? "success.main"
                                                : "error.main",
                                    },
                                },
                                {
                                    heading: "Package ID",
                                    data: {
                                        type: "text",
                                        value: offer.package_json.package_id,
                                    },
                                },
                                {
                                    heading: "Package Name",
                                    data: {
                                        type: "text",
                                        value: offer.package_json.package_name,
                                    },
                                },
                                {
                                    heading: "Package Type",
                                    data: {
                                        type: "text",
                                        value: offer.package_json.package_type,
                                    },
                                },
                                {
                                    heading: "Package Price",
                                    data: {
                                        type: "text",
                                        value: offer.package_json.package_price,
                                    },
                                },
                                {
                                    heading: "GST Amount",
                                    data: {
                                        type: "text",
                                        value: offer.package_json.gst_amount,
                                    },
                                },
                                {
                                    heading: "GST Percentage",
                                    data: {
                                        type: "text",
                                        value: offer.package_json.gst_percentage,
                                    },
                                },
                            ]}
                        />
                    </StandadCard>
                </Grid>


            </Grid>
        </Dialog>
    );
};
